var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticStyle: { display: "inline" } },
    [
      _c(
        "el-button",
        {
          attrs: { size: "small" },
          on: {
            click: function ($event) {
              _vm.productFormVisible = true
            },
          },
        },
        [_vm._v("Добавить товар")]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.products, border: "", "show-summary": "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "100", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Название", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      { attrs: { trigger: "hover", placement: "top" } },
                      [
                        _c("p", [
                          _vm._v(
                            "Дата создания: " +
                              _vm._s(
                                new Date(scope.row.dateCreate).toLocaleString()
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Дата обновления: " +
                              _vm._s(
                                scope.row.dateUpdate
                                  ? new Date(
                                      scope.row.dateUpdate
                                    ).toLocaleString()
                                  : ""
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c("el-tag", { attrs: { size: "medium" } }, [
                              _vm._v(_vm._s(scope.row.name)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "price", label: "Цена", width: "150", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Действия", fixed: "right", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button-group",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.productEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("Редактировать")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.productDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("Удалить")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.product.id
              ? "Редактирование товара"
              : "Добавление товара",
            visible: _vm.productFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.productFormVisible = $event
            },
            close: function ($event) {
              _vm.$refs.productForm.resetFields()
              _vm.product = {}
              _vm.fileList = []
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "productForm",
              attrs: {
                model: _vm.product,
                "label-position": "right",
                "label-width": "15%",
                rules: _vm.productRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Название", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.product.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "name", $$v)
                      },
                      expression: "product.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Описание", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", autosize: "" },
                    model: {
                      value: _vm.product.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "description", $$v)
                      },
                      expression: "product.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Цена", prop: "price" } },
                [
                  _c("el-input-number", {
                    attrs: { step: 0.01 },
                    model: {
                      value: _vm.product.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "price", $$v)
                      },
                      expression: "product.price",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Размер", prop: "size" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.product.size,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "size", $$v)
                      },
                      expression: "product.size",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Состав", prop: "composition" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.product.composition,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "composition", $$v)
                      },
                      expression: "product.composition",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Производитель", prop: "manufacturer" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.product.manufacturer,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "manufacturer", $$v)
                      },
                      expression: "product.manufacturer",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Фотографии", required: "" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        multiple: "",
                        limit: 10,
                        accept: "image/*",
                        action: "/api/private/photo",
                        "on-preview": _vm.handlePreview,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        headers: {
                          Authorization: "Bearer " + this.$auth.token(),
                        },
                        "file-list": _vm.fileList,
                        "list-type": "picture",
                      },
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "Фотография должна быть не более 500кб",
                            placement: "right-start",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("Добавить")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitProductForm },
                    },
                    [_vm._v("Готово")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.photoPreviewVisible },
          on: {
            "update:visible": function ($event) {
              _vm.photoPreviewVisible = $event
            },
          },
        },
        [_c("img", { attrs: { width: "100%", src: _vm.photoPreviewImageUrl } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }